var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaVolumes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic hdd",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M106.312 133H40.6875C29.8134 133 21 124.539 21 114.1V25.9C21 15.4609 29.8134 7 40.6875 7H106.312C117.187 7 126 15.4609 126 25.9V114.1C126 124.539 117.187 133 106.312 133Z",
    fill: "url(#paint0_linear_9146_76302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M106.312 133H40.6875C29.8134 133 21 125.166 21 115.5C21 105.834 29.8134 98 40.6875 98H106.312C117.187 98 126 105.834 126 115.5C126 125.166 117.187 133 106.312 133ZM106.312 109.667C102.703 109.667 99.75 112.292 99.75 115.5C99.75 118.708 102.703 121.333 106.312 121.333C109.922 121.333 112.875 118.708 112.875 115.5C112.875 112.292 109.922 109.667 106.312 109.667Z",
    fill: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M105 52.5C105 69.888 90.888 84 73.5 84C67.074 84 61.089 82.047 56.112 78.834L71.673 63.273C74.13 60.816 74.13 56.784 71.673 54.327C69.216 51.87 65.184 51.87 62.727 54.327L47.166 69.888C43.953 64.911 42 58.926 42 52.5C42 35.112 56.112 21 73.5 21C90.888 21 105 35.112 105 52.5Z",
    fill: "url(#paint1_linear_9146_76302)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9146_76302",
    x1: -36.4,
    y1: 29.2762,
    x2: 125.409,
    y2: 142.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9146_76302",
    x1: 73.5,
    y1: 21,
    x2: 73.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaVolumes);
export default __webpack_public_path__ + "static/media/figma-volumes.147157df16eaa574b16d014936107cfe.svg";
export { ForwardRef as ReactComponent };